import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
// import api from '../utils/axiosConfig';

const FacebookRedirectPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Get parameters from URL
    const email = searchParams.get('email');
    const plan = searchParams.get('plan');

    // Validate email address using regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Invalid email address');
      return;
    }

    // Payment flow disabled intentionally.
    if (email && plan) navigate('/');

  }, [navigate, searchParams]);

  // Return minimal loading state as page will redirect
  return (
    <div>
      <p>Payments are currently disabled.</p>
    </div>
  );
};

export default FacebookRedirectPage;
